<template>
  <div v-if="skeleton" class="account-section-link">
    <div class="account-section-link__icon">
      <div
        class="skeleton skeleton--bar icon--commandes"
        style="border-radius: 50%"
      >
        &nbsp;
      </div>
    </div>

    <div class="flex-grow-1">
      <p class="text-secondary lh-1">
        <span
          class="pre-title d-block mb-0-4 text-color-secondary-2 skeleton skeleton--bar"
          style="width: 50px"
          >&nbsp;</span
        >
        <span class="title skeleton skeleton--bar d-block">&nbsp;</span>
      </p>

      <p class="text-small text-md-base mb-0">
        <span class="skeleton skeleton--bar d-block" style="width: 100%"
          >&nbsp;</span
        >
        <span class="skeleton skeleton--bar d-block" style="width: 80%"
          >&nbsp;</span
        >
      </p>
    </div>
  </div>
  <nuxt-link v-else :to="to" class="account-section-link">
    <icon v-if="icon" :name="icon" class="account-section-link__icon" />

    <div>
      <p class="text-secondary lh-1">
        <span class="pre-title d-block mb-0-4 text-color-secondary-2">{{
          preTitle
        }}</span>
        <span class="title">{{ title }}</span>
      </p>

      <p class="text-small text-md-base mb-0">
        {{ description }}
      </p>
    </div>

    <div class="line line--top"></div>
    <div class="line line--bottom"></div>
    <div class="line line--left"></div>
    <div class="line line--right"></div>
  </nuxt-link>
</template>

<script>
import Icon from '@/components/icons/Icon.vue'

export default {
  name: 'AccountSectionLink',
  components: {
    Icon,
  },
  props: {
    preTitle: { type: String, required: true },
    title: { type: String, required: true },
    description: { type: String, required: true },
    to: { type: String, required: true },
    icon: { type: String, default: null },
    skeleton: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss">
.account-section-link {
  position: relative;
  background: white;
  padding: calc(var(--spacing) * 1.4) calc(var(--spacing) * 2);
  display: flex;
  cursor: pointer;

  @include mq($from: tablet) {
    padding: calc(var(--spacing) * 2);
  }

  &__icon {
    flex-shrink: 0;
    margin-right: var(--spacing);

    @include mq($from: tablet) {
      margin-right: calc(var(--spacing) * 2);
    }
  }

  .line {
    position: absolute;
    background-color: var(--yellow-color);
  }

  .line--left {
    top: 0;
    bottom: 0;
    left: 0;
    width: 0.1875rem;
    transition: width 0.4s cubic-bezier(0.46, 0.01, 0.32, 1);
  }

  .line--top,
  .line--bottom {
    left: 0;
    width: 0;
    height: 0.0625rem;
    transition: width 0.2s cubic-bezier(0.46, 0.01, 0.32, 1) 0.2s;
  }

  .line--top {
    top: 0;
  }

  .line--bottom {
    bottom: 0;
  }

  .line--right {
    top: 0;
    right: 0;
    bottom: 0;

    &::before,
    &::after {
      content: '';
      position: absolute;
      right: 0;
      width: 0.0625rem;
      height: 0;
      background-color: var(--yellow-color);
      transition: height 0.2s cubic-bezier(0.46, 0.01, 0.32, 1);
    }

    &::before {
      top: 0;
    }

    &::after {
      bottom: 0;
    }
  }

  .pre-title {
    font-size: 1.125rem;

    @include mq($from: tablet) {
      font-size: 1.375rem;
    }
  }

  .title {
    font-size: 1.75rem;

    @include mq($from: tablet) {
      font-size: 2.25rem;
    }
  }

  @include on-hover-and-focus {
    .line--left {
      width: 0.625rem;
    }

    .line--top,
    .line--bottom {
      width: 100%;
      transition-delay: 0s;
    }

    .line--right {
      &::before,
      &::after {
        height: 50%;
        transition-delay: 0.2s;
      }
    }
  }
}
</style>
